<template>

	<div v-if="vehicle" class="table-wrapper" style="flex: 1 1 auto; min-height: 0; overflow-y: auto;">
		<v-table density="compact" fixed-header class="mt-0">
			<thead>
				<tr>
					<th class="font-weight-bold text-left">Key</th>
					<th class="font-weight-bold text-right">Value</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="([key, value], index) in orderedFilteredRecords" :key="index">
					<td class="text-left">{{ key }}</td>
					<td class="text-right">
						<span v-if="key === vehicle.fields.timeKey">{{ formatDate(value) }}</span>
						<span v-else>{{ value }}</span>
					</td>
				</tr>
			</tbody>
		</v-table>
	</div>
</template>


<script setup>
import { computed } from 'vue'

const { vehicle } = defineProps(['vehicle'])

const orderedFilteredRecords = computed(() => {
	if (!vehicle.records || !vehicle.records[vehicle.P]) return []

	return Object.entries(vehicle.records[vehicle.P])
		.filter(([k]) => k !== 'id')
		.sort(([a], [b]) => a.localeCompare(b))
})

const formatDate = (value) => {
	const date = new Date(value)
	return isNaN(date) ? value : date.toLocaleString()
}
</script>

<style scoped>
.table-wrapper {
	flex: 1 1 auto;
	min-height: 0;
	/* Permite el scroll en flexbox */
	overflow-y: auto;
	max-height: 100%;
	/* Para que no crezca más que su contenedor */
}
</style>
